module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/kennedy-800.a5296696f9b35773.jpg"+" 800w",
        images: [{path: "https://static.sniffspot.com/packs/img/kennedy-800.a5296696f9b35773.jpg",width: 800,height: 594}],
        src: "https://static.sniffspot.com/packs/img/kennedy-800.a5296696f9b35773.jpg",
        toString: function(){return "https://static.sniffspot.com/packs/img/kennedy-800.a5296696f9b35773.jpg"},
        
        width: 800,
        height: 594
      }